import Conversation from '@/classes/v2/Conversation';
import Attachment from '@/classes/v2/Attachment';
import store from '@/store';

const createConversation = (state, details) => {
  state.conversations.push(new Conversation(details));
};

const setConversations = (state, conversations) => {
  state.conversations = conversations.map(rawConversation => new Conversation(rawConversation));
};

const filterConversations = (state, { conversations, currentUser }) => {
  console.log(currentUser, conversations, state.conversations);

  // state.conversations.filter(conversation => {
  //   return true;
  // })
};

const upsertMessage = (state, rawMessage) => {
  const conversation = state.conversations.find(conversation => conversation.isMyMessage(rawMessage));
  if (conversation) {
    conversation.upsertMessage(rawMessage);
  } else {
    let newConvo = new Conversation(rawMessage);
    const currentUser = store.getters['user/currentUser'];
    if (currentUser.number !== rawMessage.from &&
      ((this && this.conversationId !== this.activeConversationId) || !document.hasFocus())) {
      newConvo.unreadMessages += 1;
    }
    state.conversations.push(newConvo);
  }
};

const deleteMessageByRowId = (state, { rowId }) => {
  const conversation = state.conversations.find(conversation => conversation.findMessageByRowId(rowId));
  if (conversation) {
    conversation.deleteMessageByRowId(rowId);
  }
};

const deleteConversationByConversationId = (state, { conversationId }) => {
  const conversationIndex = state.conversations.findIndex(conversation => conversation.conversationId === conversationId);
  if (conversationIndex !== -1) {
    state.conversations.splice(conversationIndex, 1);
  }
};

const updateMessageAttachments = (state, { conversationId, attachmentsId, attachments }) => {
  const conversation = state.conversations.find(conversation => conversation.conversationId === conversationId);

  if (!conversation) {
    console.error(`updateMessageAttachments() - Unable to find conversation with id ${conversationId}`);
    return;
  }
  const message = conversation.messages.find(message => message.attachmentsId === attachmentsId);
  if (message) {
    message.attachments = attachments.map(attachment => new Attachment(attachment));
  }
};

const upsertMultipleMessages = (state, { conversationId, messages }) => {
  const conversation = state.conversations.find(conversation => conversation.conversationId === conversationId);
  conversation.upsertMultipleMessages(messages);
};

const setActiveConversationId = (state, conversationId) => {
  const conversation = state.conversations.find(conversation => conversation.conversationId === conversationId);
  conversation?.clearUnreadMessages();

  state.activeConversationId = conversationId;
};

const clearUnreadMessagesForActiveConversation = state => {
  const conversation = state.conversations.find(
    conversation => conversation.conversationId === state.activeConversationId
  );
  conversation?.clearUnreadMessages();
};

const clearUnreadMessagesForNumber = (state, number) => {
  const conversation = state.conversations.find(
    conversation => conversation.contact.number === number
  );
  conversation?.clearUnreadMessages();
};

const addTmpMessage = (state, message) => {
  state.tmpMessages.push(message);
};

const clearTmpMessages = state => {
  state.tmpMessages = [];
};

export default {
  addTmpMessage,
  clearTmpMessages,
  clearUnreadMessagesForActiveConversation,
  clearUnreadMessagesForNumber,
  createConversation,
  filterConversations,
  setConversations,
  updateMessageAttachments,
  upsertMultipleMessages,
  upsertMessage,
  setActiveConversationId,
  deleteMessageByRowId,
  deleteConversationByConversationId,
};
